import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { Country } from '../../dto/country';
import { environment } from '../../../environments/environment';
import { TotalCardOrder } from '../../dto/total-card-order';
import {CorporateForm} from '../../dto/corporate-form';
import {TotalCardCardDefinitionsModel} from '../../models/total-card-card-definitions-model';

@Injectable()
export class TotalCardOrderService {


  readonly apiPath = environment.baseUrl + 'total-card-order-assist/';
  readonly headers = { headers: new HttpHeaders({ 'No-Auth': 'True' }) };
  constructor(
      private http: HttpClient,
  ) { }

  getCorporateForms(): Observable<any> {
    return this.http.get(this.apiPath + 'corporate-forms') as Observable<CorporateForm[]>;
  }

  getCardDefinitions(): Observable<any> {
    return this.http.get(this.apiPath + 'card-definitions') as Observable<TotalCardCardDefinitionsModel>;
  }

    getCountries(): Observable<any> {
      return this.http.get(this.apiPath + 'countries') as Observable<Country[]>;
    }
    getNationalities(): Observable<any> {
      return this.http.get(this.apiPath + 'nationalities') as Observable<Country[]>;
    }
    sendMsgConfCode(phone: string): Observable<any> {
      return this.http.post(this.apiPath + 'phone-msg-conf', { phone }, this.headers);
    }
    validateConfCode(phone: string, phoneCode: string): Observable<any> {
      return this.http.post(this.apiPath + 'validate-phone-msg-conf', { phone, phoneCode }, this.headers);
    }

    createOrder(order: TotalCardOrder): Observable<TotalCardOrder> {
      order.orderDate = new Date();
      return this.http.post(this.apiPath, order) as Observable<TotalCardOrder>;
    }

    validateEmail(email: any): any {
      return this.http.get(this.apiPath + 'check-email/' + encodeURIComponent(email));
    }

}
